"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Producer = void 0;
const Resources_1 = require("../../Resources");
const IAward_1 = require("../IAward");
class Producer {
    constructor() {
        this.name = 'Producer';
        this.description = 'Have the most sets of all 6 productions';
    }
    getScore(player) {
        let score = Math.min(player.getProduction(Resources_1.Resources.MEGACREDITS), player.getProduction(Resources_1.Resources.STEEL), player.getProduction(Resources_1.Resources.TITANIUM), player.getProduction(Resources_1.Resources.PLANTS), player.getProduction(Resources_1.Resources.ENERGY), player.getProduction(Resources_1.Resources.HEAT));
        return score + IAward_1.getAdditionalScore(player);
    }
}
exports.Producer = Producer;
//# sourceMappingURL=Producer.js.map